(ns minorodata.global-search.events
  (:require [minorodata.app.handlers :refer [reg-event-db reg-event-fx]]))


;; Recently-opened search results, persisted to localStorage so they survive
;; reloads. We keep the canonical copy in re-frame db (reactive) and mirror it
;; to localStorage on every change; `load-recent` rehydrates db from storage.
(def max-recent 5)

(defn recent-key
  "User-scoped localStorage key, so recents don't leak across accounts sharing a
  browser (mirrors the pipeline editor's per-uid key)."
  [uid]
  (str "global-search-recent-" uid))


(reg-event-db
 :global-search/set-results
 (fn [db [{:keys [results pagination sort]}]]
   (assoc db
          :global-search/results    (vec results)
          :global-search/pagination pagination
          :global-search/sort       sort)))


(reg-event-fx
 :global-search/load-recent
 ;; Rehydrate the recent list from localStorage into db. The key depends on the
 ;; current user, so read storage directly here (a static cofx can't see db).
 ;; JSON parses to a JS object, so keywordize back into idiomatic clj maps.
 (fn [{:keys [db]} _]
   (let [stored (some-> (.getItem js/localStorage (recent-key (get-in db [:app :user-id])))
                        js/JSON.parse
                        (js->clj :keywordize-keys true))]
     {:db (assoc db :global-search/recent (vec stored))})))


(reg-event-fx
 :global-search/record-recent
 ;; Prepend an opened result, dedup by [type id], cap the list, persist. We
 ;; store a slim entry (no description — bulky and goes stale).
 (fn [{:keys [db]} [{:keys [type id name metadata]}]]
   (when (and type id)
     (let [entry  {:type type :id id :name name :metadata metadata}
           recent (->> (:global-search/recent db)
                       (remove #(and (= (:type %) type) (= (:id %) id)))
                       (cons entry)
                       (take max-recent)
                       vec)]
       {:db                (assoc db :global-search/recent recent)
        :set-local-storage [(recent-key (get-in db [:app :user-id])) recent]}))))


(reg-event-fx
 :global-search/clear-recent
 (fn [{:keys [db]} _]
   {:db                (assoc db :global-search/recent [])
    :set-local-storage [(recent-key (get-in db [:app :user-id])) []]}))


(reg-event-db
 :global-search/clear
 (fn [db _]
   (dissoc db
           :global-search/results
           :global-search/pagination
           :global-search/sort)))


(reg-event-fx
 :global-search/open-in-pipeline-editor
 ;; Open a search result (transform / extract) as a tab in the Pipeline Editor.
 ;; Transforms key off their parent `:group_id`, extracts off their parent
 ;; `:source_id` (see kioku.model.search metadata shapes). The navigate-or-open
 ;; handoff (and the editor-mounted check) lives in
 ;; `:pipeline-editor.events/navigate-and-open-tab`.
 (fn [_ [{:keys [type id name metadata]}]]
   (let [{:keys [master-id group-id source-id]} metadata
         tab (case type
               "transform" {:id master-id :group-id group-id  :type "transform" :name name}
               "extract"   {:id id :group-id source-id :type "extract"   :name name}
               nil)]
     (when tab
       {:dispatch [:pipeline-editor.events/navigate-and-open-tab tab]}))))
